import { signal } from "@preact/signals-react";
import { getStorage } from "../helpers/helper";
import { createTheme } from "@mui/material/styles";

export const convertHexToRGBA = (hex, opacity) => {
  // Remove the leading # if present
  hex = hex.replace(/^#/, "");

  // Parse r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Construct the rgba color string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const primary = signal(
  getStorage("SealsRepTheme") != "" ? getStorage("SealsRepTheme") : "#d09c3e"
);

export const primaryFount = signal("#fff");
export const secondary = signal(convertHexToRGBA(primary.value, 0.15));


export const themeMode = signal('light');

const getTheme = (mode = "dark") =>
  createTheme({
    palette: {
      mode,
      ...(mode === "dark"
        ? {
            background: {
              default: "#121212",
              paper: "#1e1e1e",
            },
            text: {
              primary: "#fff",
              secondary: "#aaa",
            },
          }
        : {}),
    },
    typography: {
      fontFamily: "Cairo, Roboto, sans-serif",
    },
  });

export default getTheme;
